import { useMemo } from 'react';

import { TileNode } from '@/components/diagrams/FlowChart';
import { TypeaheadSelectInputOption } from '@/components/form/baseInputs/inputTypes';

import type { TileNotesGenerationTarget } from './useTileNotesGenerationTarget';

export interface EntityTileOptionsInput {
  tileNodes: TileNode[];
  target: TileNotesGenerationTarget | null;
}

export function getEntityTileOptions({
  tileNodes,
  target,
}: EntityTileOptionsInput): TypeaheadSelectInputOption<string>[] {
  if (!target) return [];

  return tileNodes.flatMap((tile) => {
    const lineOne =
      typeof tile.data.lineOne === 'string' ? tile.data.lineOne : undefined;

    if (!lineOne || target.buildInputForTile(tile.id).length === 0) {
      return [];
    }

    return [
      {
        value: tile.id,
        display: lineOne,
      },
    ];
  });
}

export function useEntityTileOptions({
  tileNodes,
  target,
}: EntityTileOptionsInput) {
  return useMemo(
    () => getEntityTileOptions({ tileNodes, target }),
    [tileNodes, target]
  );
}
